<!--
 * @Author: lijiahui
 * @Date: 2021-01-13 17:08:22
 * @LastEditTime: 2022-07-27 15:44:52
 * @LastEditors: 李嘉辉 LiJiaHui0908
 * @Description: 收藏夹亲子儿歌
 * @FilePath: \xingmahui_front\src\components\Profile\childSongs.vue
-->

<template>
  <div class="childSongs">
    <van-list v-model="childSongsParams.Loading" :error.sync="childSongsParams.Error"
              :finished="childSongsParams.Finished" :finished-text="childSongsParams.finishText"
              error-text="请求失败，点击重新加载" @load="getSongsList">
      <div class="childList">
        <div v-for="(item,index) in childSongsList" :key="index" class="childItem">
          <!--<childVideo :videoDetail="videoDetail" :userInfo="userInfo"></childVideo>-->
          <!-- <childVideo v-if="videoDetail.allId==item.allId" ref="childVideos" :isVideoState="isVideoState" :videoDetail="videoDetail" :userInfo="userInfo" :onlyVideo="true"></childVideo> -->
          <div v-lazy:background-image="item.coverUrl" :class="'imgs'+item.id" class="img" @click="startVideo(item.id)">
            <img alt="" class="off" src="./../../../assets/images/icon/off.png">
            <div class="shadow">
            </div>
            <img class="playNumarrow" src="./../../../assets/images/icon/vedio_three.png" alt="">
            <span class="playNum">{{item.watchNum?fomatterNum(item.watchNum):'0'}}次播放</span>
            <span class="time">{{item.durationStr}}</span>
          </div>
          <div class="title">{{ item.name }}</div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import childVideo from '@/components/contents/calendar/video.vue';
import {Debounce, fomatterNum, getCookie} from "@/assets/js/common.js";
import API from "@/utils/axiosApi/childSongsApi.js";

export default {
  name: 'childSongs',
  data() {
    return {
      childSongsParams: {
        page: 1,
        size: 25,
        Loading: false, // 是否加载状态
        Finished: false, // 是否加载完成
        Error: false, // 是否加载失败
        finishText: '', // 加载完成文本
      },
      childSongsList: [], // 视频列表
      userInfo: {}, // 用户信息
      videoDetail: [], // 当前播放视频信息
      switchName: '', // 切换tab前的播放的类名
      videoCollectState: false, // 用户是否取消收藏
    }
  },
  props: ['isVideoState'],
  watch: {
    isVideoState(val) {
      if (!val && $('video')[0]) {
        this.videoDetail = []
        this.switchName = this.$store.state.pageState
        document.getElementsByClassName(this.switchName)[0].style.display = 'block'
      }
    }
  },
  activated() {
    this.initFn()
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    // this.getSongsList()
  },
  components: {childVideo},
  methods: {
    startVideo(id) {
      this.$router.push({
        name: 'parentchildsongsdetail',
        query: {
          id: id
        }
      })
    },
    getSongsList: function () {
      document.getElementsByClassName('childSongs')[0].style.minHeight = (window.innerHeight - 52) + 'px';
      const that = this;
      API.getCollectByParentSongs({}, {
        data: {"crmId": this.userInfo.crm_id,},
        "page": this.childSongsParams.page,
        "size": this.childSongsParams.size
      }, res => {
        this.childSongsParams.Loading = false;
        if (res.code == 200) {
          this.childSongsList = this.childSongsList.concat(res.data.data)
          this.childSongsList.forEach((item, index) => {
            // item.playState = false
            item.allId = index + 1;
            item.type = '3'
          })
          if (that.childSongsParams.page >= Math.ceil(res.data.total / that.childSongsParams.size)) {
            this.childSongsParams.Finished = true;
            this.childSongsParams.finishText = "——已经到底了哦——";
          } else {
            this.childSongsParams.page += 1;
          }
          if (this.childSongsParams.page == 1 && res.data.data.length == 0) {
            document.getElementsByClassName('childSongs')[0].style.minHeight = '0px';
            this.childSongsParams.finishText = "";
            this.$emit('isEmpty', true)
            $(".van-tabs__content").css("background", "#fff");
          }
        } else {
          this.childSongsParams.Loading = false;
          this.childSongsParams.Error = true
        }
      }, res => {
        this.childSongsParams.Loading = false;
        this.childSongsParams.Error = true;
      })
    },
    initFn() {
      this.childSongsParams.Finished = false;
      this.childSongsParams.Error = false;
      this.childSongsParams.Loading = false;
      this.childSongsList = [];
      this.childSongsParams.page = 1;
    },
    // 点赞
    onLike: Debounce(function (item, index) {
      // type 1精选视频 2其他视频
      const {orLike, like, id} = this.childSongsList[index];
      if (!item.orLike) { // 点赞
        this.addLike(item, 'add', () => {
          this.childSongsList[index].likeNum += 1;
          this.childSongsList[index].orLike = !orLike;
        })
        sensors.track('Support', {
          'content_id': item.id,
          'content_title': item.name,
          'Column': '亲子儿歌',
          'Poster_Date': '',
          //   'A_B_flow': ''
        })
      } else { // 取消点赞
        this.addLike(item, 'cancel', () => {
          this.childSongsList[index].likeNum -= 1;
          if (like < 0) {
            this.childSongsList[index].likeNum = 0;
          }
          this.childSongsList[index].orLike = !orLike;
        })
        sensors.track('Unsupport', {
          'content_id': item.id,
          'content_title': item.name,
          'Column': '亲子儿歌',
          'Poster_Date': '',
          //   'A_B_flow': ''
        })
      }
    }, 100),
    // 收藏
    onCllect: Debounce(function (item, index) {
      const {orFavorites, collect, id} = this.childSongsList[index];
      if (!item.orFavorites) { // 收藏
        this.addCllect(item, 'add', () => {
          this.childSongsList[index].collectNum += 1;
          this.childSongsList[index].orFavorites = !orFavorites;
        })
        sensors.track('Save', {
          'content_id': item.id,
          'content_title': item.name,
          'Column': '亲子儿歌',
          'Poster_Date': '',
          //   'A_B_flow': ''
        })
      } else { // 取消收藏
        this.addCllect(item, 'cancel', () => {
          this.childSongsList[index].collectNum -= 1;
          if (collect < 0) {
            this.childSongsList[index].collectNum = 0;
          }
          this.childSongsList[index].orFavorites = !orFavorites;
        })
        sensors.track('CancelSave', {
          'content_id': item.id,
          'content_title': item.name,
          'Column': '亲子儿歌',
          'Poster_Date': '',
          //   'A_B_flow': ''
        })
      }
    }, 100),
    // 分享
    shareLink: Debounce(function (item, index, className) {
      if ($('video')[0]) {
        var name = this.$store.state.pageState == className ? className : this.$store.state.pageState
        this.videoDetail = []
        this.$refs.childVideos[0].Player.destroy(true);
        document.getElementsByClassName(name)[0].style.display = 'block'
      }
      this.$emit('audioChildEvent', true);
      API.addShare({ id: item.id }, {}, res => {
          if (res.code == '200') {
            this.childSongsList[index].shareNum += 1;
            sensors.track('Share', {
                'content_id': item.id,
                'content_title': item.name,
                'Column': '亲子儿歌',
                'Poster_Date': '',
                // 'A_B_flow': ''
            })
        }
      })
    }, 100),
    // 收藏接口
    addCllect(item, type, callback) {
      if (type == 'add') {
        API.addCollect({crmId: this.userInfo.crm_id, id: item.id}, {}, res => {
          if (res.code == '200') {
            this.$toast({
              duration: 3000,
              message: '收藏成功',
              context: this
            });
            callback();
          }
        })
      } else {
        API.cancelCollect({crmId: this.userInfo.crm_id, id: item.id}, {}, res => {
          if (res.code == '200') {
            this.childSongsList = [],
                this.videoDetail = [],
                this.videoCollectState = true, // 判断用户取消收藏
                this.getSongsList()
            callback();
          }
        })
      }
    },
    // 点赞接口
    addLike(item, type, callback) {
      if (type == 'add') {
        API.addLike({crmId: this.userInfo.crm_id, id: item.id}, {}, res => {
          if (res.code == '200') {
            this.$toast({
              duration: 3000,
              message: '点赞成功',
              context: this
            });

            callback();
          }
        })
      } else {
        API.cancelLike({crmId: this.userInfo.crm_id, id: item.id}, {}, res => {
          if (res.code == '200') {
            callback();
          }
        })
      }
    },
    fomatterNum, Debounce, getCookie
  }
}
</script>

<style lang="less" scoped>
.childSongs {
  background: #f2f2f2;
  height: 100%;

  .childList {
    // padding: 12px 8px 0;
    overflow: hidden;

    .childItem {
      background: #fff;
      margin: 12px 12px 0;
      // height: 217px;
      width: 351px;
      float: left;
      border-radius: 8px;
      overflow: hidden;

      .title {
        font-size: 14px;
        padding: 8px 12px;
        font-weight: 500;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;
      }

      .lump {
        float: left;
        width: 100%;
        // height: 36px;
        background: #f9f9f9;
        border-radius: 0px 0px 8px 8px;

        .operationBlock {
          width: 350px;
          overflow: hidden;
          margin: 0 auto;

          .state {
            width: 33.33%;
            text-align: center;
            font-size: 14px;
            color: #999999;
            line-height: 1;
            float: left;
            padding: 13px 0;

            img {
              width: 14px;
              height: 14px;
              margin-right: 3px;
              vertical-align: middle;
            }

            span {
              vertical-align: text-bottom;
            }
          }
        }
      }

      .img {
        position: relative;
        height: 197px;
        width: 100%;
        background-size: 100% 100%;

        .off {
          width: 48px;
          height: 48px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        .playNum {
          position: absolute;
          bottom: 2px;
          left: 25px;
          z-index: 11;
          color: #fff;
          font-size: 12px;
        }

        .playNumarrow {
          width: 8px;
          height: 9px;
          position: absolute;
          bottom: 5px;
          left: 14px;
          z-index: 11;
          border-radius: 2px;
        }

        .time {
          position: absolute;
          bottom: 2px;
          right: 10px;
          color: #fff;
          z-index: 11;
          font-size: 12px;
        }
      }
    }
  }
}

/deep/ .van-list__finished-text {
  background: #f2f2f2;
  padding: 60px 0;
}

.childItem {
  position: relative;
}

// .childItem .playNum ::after{
//     position: absolute;
//     left: 0;
//     content: "";
//     background-color: #000000;
//     opacity: 0.3;
//     z-index: 10;
//     width: 100%;
//     height: 26px;
//     bottom: 32px;
// }
.shadow {
  position: absolute;
  bottom: 0px;
  left: 0;
  opacity: 0.3;
  height: 20px;
  width: 100%;
  background: #000000;
}
</style>
